import { StageType } from 'modules/championship/domain/enums/stage-type';
import { compareTeamGroups } from 'modules/championship/domain/utils/compare-team-groups';
import type { StageRenderTargetsGql } from 'modules/manager/domain/graphql/stage-render-targets';
import type { StageRenderTarget } from 'modules/manager/domain/interfaces/stage-render-target';

/**
 * Этап → список картинок турнирной таблицы: групповой этап — по картинке на группу, в
 * порядке групп из админки (`compareTeamGroups`); любой другой — одна картинка без группы.
 *
 * Групповой этап без единой группы тоже даёт одну цель без `groupId`: картинку «весь этап»
 * бэкенд нарисовать может, а пустой список оставил бы превью без запроса и без объяснения.
 *
 * `teamGroups` фильтруются по `stage.id` так же, как в `stage.repository.ts`: бэкенд
 * отдавал в этом поле и группы соседних этапов.
 */
export function mapStageRenderTargets(stage: StageRenderTargetsGql): StageRenderTarget[] {
  if (stage.type !== StageType.GROUP) {
    return [{}];
  }

  const groups = (stage.teamGroups ?? []).filter((group) => group.stage.id === stage.id).sort(compareTeamGroups);

  if (groups.length === 0) {
    return [{}];
  }

  return groups.map((group) => ({ groupId: group.id, groupName: group.name }));
}
